// Firestore-backed RSVP store: events/{EVENT_ID}/rsvps/{uid}
import {
  doc,
  setDoc,
  deleteDoc,
  getDoc,
  collection,
  getDocs,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { db, EVENT_ID } from "./firebase";

const rsvpsCol = () => collection(db, "events", EVENT_ID, "rsvps");
const rsvpDoc = (uid) => doc(db, "events", EVENT_ID, "rsvps", uid);

export const getMyRsvp = async (uid) => {
  const snap = await getDoc(rsvpDoc(uid));
  return snap.exists() ? snap.data() : null;
};

export const upsertRsvp = (uid, data) =>
  setDoc(
    rsvpDoc(uid),
    { ...data, uid, updatedAt: serverTimestamp() },
    { merge: true }
  );

export const removeRsvp = (uid) => deleteDoc(rsvpDoc(uid));

export const fetchAllRsvps = async () => {
  const snap = await getDocs(rsvpsCol());
  return snap.docs.map((d) => d.data());
};

export const subscribeAllRsvps = (onData, onError) =>
  onSnapshot(rsvpsCol(), (snap) => onData(snap.docs.map((d) => d.data())), onError);

export const totalPlates = (list) =>
  list.filter((g) => g.accepted).reduce((s, g) => s + Number(g.seats || 0), 0);

// RSVPs saved before the per-event choice existed count as "attending both".
export const eventsOf = (g) => ({ marriage: true, reception: true, ...(g.events || {}) });

export const eventsLabel = (g) => {
  if (!g.accepted) return "—";
  const e = eventsOf(g);
  const picked = [e.marriage && "Marriage", e.reception && "Reception"].filter(Boolean);
  return picked.length ? picked.join(" + ") : "—";
};

// Plates for one function only — the number catering actually needs per day.
export const platesFor = (list, key) =>
  list
    .filter((g) => g.accepted && eventsOf(g)[key])
    .reduce((s, g) => s + Number(g.seats || 0), 0);

export const exportRsvpCsv = (guests) => {
  const attending = guests.filter((g) => g.accepted);
  const rows = [
    ["Name", "Seats", "Events", "Email", "Status"],
    ...guests.map((g) => [
      g.name,
      g.seats,
      eventsLabel(g),
      g.email,
      g.accepted ? "Attending" : "Not attending",
    ]),
    [],
    ["Total attending parties", attending.length],
    ["Total plates to arrange", totalPlates(guests)],
    ["Plates — Marriage", platesFor(guests, "marriage")],
    ["Plates — Reception", platesFor(guests, "reception")],
  ];
  const csv = rows
    .map((r) => r.map((c) => `"${String(c ?? "")}"`).join(","))
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "wedding-guest-list-catering.csv";
  a.click();
  URL.revokeObjectURL(url);
};
